export const SOUS_TOTAL = 'Soustotal';
export const REMISE = 'Remise';
export const NORMAL = 'Normal';
export const COMMENTAIRE = 'Commentaire';
export const REGROUPEMENT = 'Regroupement';
export const PERSONNALISE = 'Personnalise';
export const LOCATION = 'Location';

export const JOUR = 'Jour';
export const SEMAINE = 'Semaine';
export const MOIS = 'Mois';
export const TRIMESTRIEL = 'Trimestriel';
export const SEMESTRIEL = 'Semestriel';
export const ANNEE = 'Annee';
export const UNITE = 'Unite';
export const POURCENTAGE = 'Pourcentage';
export const METRE_CARRE = 'MetreCarre';
export const FACE = 'Face';
export const ENCART = 'Encart';
export const PARUTION = 'Parution';

export const LISTE_UNITE_ECHEANCIER_FACTURATION = [
  { code: JOUR, libelle: 'general.quantity.day' },
  { code: MOIS, libelle: 'general.quantity.month' },
  { code: ANNEE, libelle: 'general.quantity.year' },
];

export const LISTE_TYPE_LIGNE = [
  { code: SOUS_TOTAL, libelle: 'dcf.lineType.sousTotal' },
  { code: REMISE, libelle: 'dcf.lineType.remise' },
  { code: NORMAL, libelle: 'dcf.lineType.normal' },
  { code: COMMENTAIRE, libelle: 'dcf.lineType.commentaire' },
  { code: REGROUPEMENT, libelle: 'dcf.lineType.regroupement' },
  { code: PERSONNALISE, libelle: 'dcf.lineType.personnalise' },
  { code: LOCATION, libelle: 'dcf.lineType.location' },
];

export const MAJORATION = 'Majoration';
export const REDUCTION = 'Reduction';
export const REMPLACEMENT_PU = 'Remplacement';

export const TYPE_REMISE_FRONT_MAJORATION_MONTANT = 'Majoration montant';
export const TYPE_REMISE_FRONT_REMISE_MONTANT = 'Reduction montant';
export const TYPE_REMISE_FRONT_MAJORATION_POURCENTAGE = 'Majoration pourcentage';
export const TYPE_REMISE_FRONT_REMISE_POURCENTAGE = 'Reduction pourcentage';

export const LISTE_HABITANTS_OPERATEURS = [
  {
    code: '>',
    libelle: 'ajoutDevis.superieurA',
  }, {
    code: '=',
    libelle: 'ajoutDevis.egaleA',
  }, {
    code: '<',
    libelle: 'ajoutDevis.inferieurA',
  },
];

export const LISTE_UNITES = [
  {
    code: JOUR,
    initiale: 'general.quantity.initialDay',
    libelle: 'general.quantity.day',
    libelleLight: 'general.quantityLight.day',
  },
  {
    code: SEMAINE,
    initiale: 'general.quantity.initialWeek',
    libelle: 'general.quantity.week',
    libelleLight: 'general.quantityLight.week',
  },
  {
    code: MOIS,
    initiale: 'general.quantity.initialMonth',
    libelle: 'general.quantity.month',
    libelleLight: 'general.quantityLight.month',
  },
  {
    code: ANNEE,
    initiale: 'general.quantity.initialYear',
    libelle: 'general.quantity.year',
    libelleLight: 'general.quantityLight.year',
  },
  {
    code: UNITE,
    initiale: 'general.quantity.initialUnity',
    libelle: 'general.quantity.unity',
    libelleLight: 'general.quantityLight.unity',
  },
  {
    code: POURCENTAGE,
    initiale: 'general.quantity.initialPercent',
    libelle: 'general.quantity.percent',
    libelleLight: 'general.quantityLight.percent',
  },
  {
    code: METRE_CARRE,
    initiale: 'general.quantity.initialMetreCarre',
    libelle: 'general.quantity.metreCarre',
    libelleLight: 'general.quantityLight.metreCarre',
  },
  {
    code: FACE,
    initiale: 'general.quantity.initialFace',
    libelle: 'general.quantity.face',
    libelleLight: 'general.quantityLight.face',
  },
  {
    code: ENCART,
    initiale: 'general.quantity.initialEncart',
    libelle: 'general.quantity.encart',
    libelleLight: 'general.quantityLight.encart',
  },
  {
    code: PARUTION,
    initiale: 'general.quantity.initialParution',
    libelle: 'general.quantity.parution',
    libelleLight: 'general.quantityLight.parution',
  },
];

export const MONTANT = 'Montant';
export const PERSONALISE = 'Personalise';

export const LISTE_TYPE_REMISE_LIGNE = [
  { code: TYPE_REMISE_FRONT_REMISE_MONTANT, initiale: 'general.discountType.montantRemise', libelle: 'general.discountType.montantRemise' },
  { code: TYPE_REMISE_FRONT_MAJORATION_MONTANT, initiale: 'general.discountType.montantMajoration', libelle: 'general.discountType.montantMajoration' },
  { code: TYPE_REMISE_FRONT_REMISE_POURCENTAGE, initiale: 'general.discountType.pourcentageRemise', libelle: 'general.discountType.pourcentageRemise' },
  { code: TYPE_REMISE_FRONT_MAJORATION_POURCENTAGE, initiale: 'general.discountType.pourcentageMajoration', libelle: 'general.discountType.pourcentageMajoration' },
  { code: PERSONALISE, initiale: 'general.discountType.initialCustom', libelle: 'general.discountType.custom' },

];

export const TYPE_REMISE_CUMULE = 'Cumule';
export const TYPE_REMISE_CASCADE = 'Cascade';
export const TYPE_REMISE_SOUS_TOTAL = 'SousTotal';

export const LISTE_TYPE_REMISE = [
  { show: true, code: TYPE_REMISE_CUMULE, libelle: 'general.discountTypeLigne.accrued' },
  { show: true, code: TYPE_REMISE_CASCADE, libelle: 'general.discountTypeLigne.cascade' },
  { show: false, code: TYPE_REMISE_SOUS_TOTAL, libelle: 'general.discountTypeLigne.sousTotal' },
];

export const LISTE_TYPE_REMISE_BACK = [{ code: MONTANT, libelle: 'general.discountType.money' }, { code: POURCENTAGE, libelle: 'general.discountType.pourcentage' }];

export const LISTE_SAISIES = [
  { code: TYPE_REMISE_FRONT_MAJORATION_MONTANT, libelle: 'general.discountType.montantMajoration' },
  { code: TYPE_REMISE_FRONT_REMISE_MONTANT, libelle: 'general.discountType.montantRemise' },
  { code: TYPE_REMISE_FRONT_MAJORATION_POURCENTAGE, libelle: 'general.discountType.pourcentageMajoration' },
  { code: TYPE_REMISE_FRONT_REMISE_POURCENTAGE, libelle: 'general.discountType.pourcentageRemise' },
];

export const INTERVENANT_REPARTITION_TYPE = [
  { code: MONTANT, libelle: 'general.discountType.money' },
  { code: POURCENTAGE, libelle: 'general.discountType.pourcentage' },
];

export const LISTE_COMMERCIAL = [
  {
    id: '0c0c7c5d-1459-f783-ec39-e1c4f56e7487',
    nom: 'Bill Gates',
    email: 'b.gates@hotmail.fr',
    phone: '0610203040',
  },
  {
    id: 'ede96b32-f5bb-729b-cc40-e20a82cd779d',
    nom: 'Bruce Wayne',
    email: 'admin@wayneenterprise.com',
    phone: '0610203040',
  },
];

export const LISTE_ASSISTANTE = [
  { id: '0c0c7c5d-1459-f783-ec39-e1c4f56e7488', nom: 'Melinda Gates' },
  { id: 'ede96b32-f5bb-729b-cc40-e20a82cd779e', nom: 'Alfred Pennyworth' },
];

export const TYPE_DEVIS = 'Devis';
export const TYPE_COMMANDE = 'Commande';
export const TYPE_FACTURE = 'Facture';

export const LISTE_TYPE_DEVIS_COMMANDE = [
  { code: TYPE_DEVIS, libelle: 'previsionnelDepart.types.devis' },
  { code: TYPE_COMMANDE, libelle: 'previsionnelDepart.types.commande' },
];

export const LISTE_TYPE_DEVIS_COMMANDE_FACTURE = [
  { code: TYPE_DEVIS, libelle: 'previsionnelDepart.types.devis' },
  { code: TYPE_COMMANDE, libelle: 'previsionnelDepart.types.commande' },
  { code: TYPE_FACTURE, libelle: 'previsionnelDepart.types.facture' },
];

export const SOUS_TYPE_NORMAL = 'Normal';
export const SOUS_TYPE_AVOIR = 'Avoir';
export const SOUS_TYPE_ACOMPTE = 'Acompte';
export const SOUS_TYPE_BON_RECEPTION = 'BonReception';
export const SOUS_TYPE_AVOIR_SUR_ACOMPTE = 'AvoirSurAcompte';

export const SENS_ACHAT = 'achat';
export const SENS_VENTE = 'vente';

export const REFERENCE_EXTERNE_CONTRAT = 'Contrat';
export const REFERENCE_EXTERNE_ANNULATION_REGLEMENT = 'AnnulationReglement';

export const MODULE_BAIL = 'Bail';
export const MODULE_GESTION_COMMERCIALE = 'GestionCommerciale';
export const MODULE_TLPE = 'Tlpe';
export const MODULE_LOGISTIQUE_TECHNIQUE = 'LogistiqueTechnique';
export const MODULE_ACHAT = 'Achat';

export const ETAT_BROUILLON = 'Brouillon';
export const ETAT_ENREGISTRE = 'Enregistre';
export const ETAT_ANNULER = 'Annulee';
export const ETAT_SANSSUITE = 'SansSuite';
export const ETAT_CLOTURER = 'Clos';
export const ETAT_FACTURE = 'Facture';
export const ETAT_PAYE = 'Paye';
export const ETAT_COMMANDE = 'Commande';
export const ETAT_FACTURE_PARTIELLEMENT = 'FactureePartiellement';
export const ETAT_COMMANDE_PARTIELLEMENT = 'CommandePartiellement';
export const ETAT_RECEPTIONNEE = 'Receptionnee';
export const ETAT_RECEPTIONNEE_PARTIELLEMENT = 'ReceptionneePartiellement';
export const ETAT_CREE = 'Cree';
export const ETAT_RAPPROCHE = 'Rapproche';
export const ETAT_RAPPROCHE_PARTIELLEMENT = 'RapprochePartiellement';

export const DEVIS_COMMANDE_ETAT = [
  { code: ETAT_ENREGISTRE, libelle: 'listeDevis.status.save' },
  { code: ETAT_COMMANDE, libelle: 'listeDevis.status.order' },
  { code: ETAT_FACTURE, libelle: 'listeDevis.status.bill' },
  { code: ETAT_FACTURE_PARTIELLEMENT, libelle: 'listeDevis.status.partBill' },
  { code: ETAT_SANSSUITE, libelle: 'listeDevis.status.sansSuite' },
  { code: ETAT_CLOTURER, libelle: 'listeDevis.status.clos' },
  { code: ETAT_COMMANDE_PARTIELLEMENT, libelle: 'listeDevis.status.commandePartiel' },
  { code: ETAT_BROUILLON, libelle: 'listeDevis.status.brouillon' },
];

export const DEVIS_ETAT = [
  { code: ETAT_BROUILLON, libelle: 'listeDevis.status.brouillon' },
  { code: ETAT_ENREGISTRE, libelle: 'listeDevis.status.save' },
  { code: ETAT_COMMANDE, libelle: 'listeDevis.status.order' },
  { code: ETAT_COMMANDE_PARTIELLEMENT, libelle: 'listeDevis.status.commandePartiel' },
  { code: ETAT_SANSSUITE, libelle: 'listeDevis.status.sansSuite' },
];

export const COMMANDE_ETAT = [
  { code: ETAT_ENREGISTRE, libelle: 'listeDevis.status.save' },
  { code: ETAT_FACTURE, libelle: 'listeDevis.status.bill' },
  { code: ETAT_FACTURE_PARTIELLEMENT, libelle: 'listeDevis.status.partBill' },
  { code: ETAT_SANSSUITE, libelle: 'listeDevis.status.sansSuite' },
  { code: ETAT_CLOTURER, libelle: 'listeDevis.status.clos' },
];

export const COMMISSIONS_ETAT = [
  { code: ETAT_ENREGISTRE, libelle: 'listeDevis.status.save' },
  { code: ETAT_FACTURE, libelle: 'listeDevis.status.bill' },
  { code: ETAT_SANSSUITE, libelle: 'listeDevis.status.sansSuite' },
];

export const COMMANDE_ACHAT_FOURNISSEUR_ETAT = [
  { code: ETAT_ENREGISTRE, libelle: 'listeDevis.status.save' },
  { code: ETAT_FACTURE_PARTIELLEMENT, libelle: 'listeDevis.status.partBill' },
  { code: ETAT_FACTURE, libelle: 'listeDevis.status.bill' },
  { code: ETAT_RECEPTIONNEE, libelle: 'listeDevis.status.receptionnee' },
  { code: ETAT_RECEPTIONNEE_PARTIELLEMENT, libelle: 'listeDevis.status.receptionneePartiellement' },
  { code: ETAT_SANSSUITE, libelle: 'listeDevis.status.sansSuite' },
];

export const BON_RECEPTION_ETAT = [
  { code: ETAT_CREE, libelle: 'listeDevis.status.cree' },
  { code: ETAT_RAPPROCHE_PARTIELLEMENT, libelle: 'listeDevis.status.rapprochePartiellement' },
  { code: ETAT_RAPPROCHE, libelle: 'listeDevis.status.rapproche' },
  { code: ETAT_FACTURE, libelle: 'listeBonReception.etatFacture' },
];

export const DEVIS_COMMANDE_TARIF = [
  {},
  { id: '0c0c7c5d-1459-f783-ec39-e1c4f56e7487', libelle: '1 an' },
  { id: '0c0c7c5d-1459-f783-ec39-e1c4f56e7486', libelle: '2 ans' },
  { id: '0c0c7c5d-1459-f783-ec39-e1c4f56e7485', libelle: '3 ans' },
  { id: '0c0c7c5d-1459-f783-ec39-e1c4f56e7484', libelle: 'mensuel' },
];

export const ETAT_RENOUVELEE = 'Renouvelee';
export const ETAT_ENATTENTE = 'EnAttente';
export const ETAT_TACITE = 'Tacite';
export const ETAT_NONRENOUVELEE = 'NonRenouvelee';
export const ETAT_ENCOURS = 'EnCours';

export const LISTE_ETAT_RENOUVELLEMENT = [
  { code: ETAT_RENOUVELEE, libelle: 'renouvellementCommande.etat.renouvele' },
  { code: ETAT_ENATTENTE, libelle: 'renouvellementCommande.etat.aRenouveler' },
  { code: ETAT_TACITE, libelle: 'renouvellementCommande.etat.tacite' },
  { code: ETAT_NONRENOUVELEE, libelle: 'renouvellementCommande.etat.nonRenouvele' },
  { code: ETAT_ENCOURS, libelle: 'renouvellementCommande.etat.enCours' },
];

export const LISTE_TYPE_MODIFICATION_PU = [
  { code: MAJORATION, libelle: 'miseAJourTarif.types.majoration' },
  { code: REDUCTION, libelle: 'miseAJourTarif.types.reduction' },
  { code: REMPLACEMENT_PU, libelle: 'miseAJourTarif.types.remplacement' },
];

export const ACTION_GROUPER_PERSONNALISE = 'GroupePerso';
export const ACTION_INFORMATION_GROUPER_PERSONNALISE = 'InformationRegroupement';
export const ACTION_GROUPER_MAJ_PU = 'MajPu';
export const ACTION_GROUPER_MAJ_TVA = 'MajTva';
export const ACTION_GROUPER_MAJ_ETAT_SOUHAITE = 'MajEtatSouhaite';
export const ACTION_GROUPER_MAJ_REMISE = 'MajRemise';
export const ACTION_REMISE_PRIX_NET_FACE = 'RemiseNetFace';
export const ACTION_FACTURATION_MASSE = 'facturationMasse';
export const ACTION_DUPLICATION = 'Duplication';
export const ACTION_MODIFIER_DATES = 'ModifierDates';

export const TYPE_EDITION_DEVIS = 'Devis';
export const TYPE_EDITION_DEVIS_MAIL = 'devis';
export const TYPE_EDITION_DEVIS_SANS_LOGO = 'DevisSansLogo';

export const TYPE_EDITION_DOSSIER_TEMPO = 'DossierTempo';

export const TYPE_GENERATION_AUCUN = 'Aucun';
export const TYPE_GENERATION_TYPE_PRODUIT = 'TypeProduit';
export const TYPE_GENERATION_PATRIMOINE = 'Patrimoine';

export const LISTE_TYPE_GENERATION = [
  { code: TYPE_GENERATION_AUCUN, libelle: 'detailDevis.commandePartiel.generation.type.aucun' },
  { code: TYPE_GENERATION_TYPE_PRODUIT, libelle: 'detailDevis.commandePartiel.generation.type.typeProduit' },
  { code: TYPE_GENERATION_PATRIMOINE, libelle: 'detailDevis.commandePartiel.generation.type.patrimoine' },
];

export const LISTE_CHOICE_EDITION_DEVIS = [
  { typeEdition: '', libelle: 'detail.edition.devis', typeDonnee: TYPE_EDITION_DEVIS },
  {
    typeEdition: '',
    libelle: 'detail.edition.devisDetailLc',
    typeDonnee: TYPE_EDITION_DEVIS,
    parametresAdditionnels: { DetailLc: 'true' },
  },
  { typeEdition: TYPE_EDITION_DEVIS_SANS_LOGO, libelle: 'detail.edition.devisSansLogo', typeDonnee: TYPE_EDITION_DEVIS },
  {
    typeEdition: '',
    libelle: 'detail.edition.dossierTempo',
    typeDonnee: TYPE_EDITION_DOSSIER_TEMPO,
    parametresAdditionnels: {
      Type: 'Devis',
      AffichageCumul: false,
    },
  },
  {
    typeEdition: '',
    libelle: 'detail.edition.dossierTempoAvecCumul',
    typeDonnee: TYPE_EDITION_DOSSIER_TEMPO,
    parametresAdditionnels: {
      Type: 'Devis',
      AffichageCumul: true,
    },
  },
  {
    typeEdition: '',
    libelle: 'catalogue.edition.diaporama',
    typeDonnee: 'Diaporama',
    parametresAdditionnels: {
      typeSource: 'dcf',
      isCBA: true,
    },
  },
];

export const EXPORT_EXCEL_DEVIS = 'devis';
export const EXPORT_EXCEL_LIGNE_COMMANDE_A_RENOUVELER = 'lignecommandearenouveler';
export const EXPORT_EXCEL_LIGNE_DEVIS = 'lignedevis';
export const ACTION_SANS_SUITE = 'sansSuite';
